import React, { Component } from 'react';
import { Select, Input } from "../partials";

class Range extends Component {

    constructor(props) {
        super(props);

        // Inputs cant have 'value' = null
        // So need to set them to empty string by default
        const val = props.type === 'select' ? null : '';
    
        this.state = {
            from: val,
            to: val
        };
    }
    
    componentDidMount() {
        const { preSelectFrom, preSelectTo } = this.props;

        // If preSelect exists
        if (preSelectFrom) {
            this.setState({ from: preSelectFrom.value });
        };

        if (preSelectTo) {
            this.setState({ to: preSelectTo.value });
        };
    }

    componentDidUpdate() {
        const { value } = this.props;

        // For cases when we want to contol the selected value from the parent components
        // For example on "clear" click
        if (typeof value !== 'undefined'){
            if (value.from !== this.state.from){
                this.setState({ from: value.from });
            }
            if (value.to !== this.state.to){
                this.setState({ to: value.to });
            }
        }
    }

    onChangeFrom = (value) => {
        const { to } = this.state;
        const from = this.getVal(value);
        this.change({ from, to });
    };

    onChangeTo = (value) => {
        const { from } = this.state;
        const to = this.getVal(value);
        this.change({ from, to });
    };

    change = (range) => {
        const { onChange } = this.props;

        onChange({ range });
        this.setState(range);
    };

    getVal = (value) => {
        const { type } = this.props;
        if (type === 'select') {
            return value.value;
        };
        if (type === 'price') {
            return value.target.value;
        };

        return null;
    };

    render() {
        const { options, label, type, name, onChange, value, preSelectFrom, preSelectTo, ...rest } = this.props;

        let from;
        let to;

        if (type === 'select') {
            from = <Select name={`${name}-from`} 
                        options={options} 
                        onChange={this.onChangeFrom}
                        preSelect={preSelectFrom}
                        defaultValue={preSelectFrom ?? options[0]}
                        value={this.state.from} 
                        modifiers={['filter']}
                        {...rest} 
                    />;
            to = <Select 
                    name={`${name}-to`} 
                    options={options} 
                    onChange={this.onChangeTo}
                    preSelect={preSelectTo}
                    defaultValue={preSelectTo ?? options[0]}
                    value={this.state.to} 
                    modifiers={['filter']}
                    {...rest} 
                />;
        };

        if (type === 'price') {
            from = <Input name={`${name}-from`} onChange={this.onChangeFrom} value={this.state.from} modifiers={['filter', 'price']} placeholder={`Any`}/>
            to = <Input name={`${name}-to`} onChange={this.onChangeTo} value={this.state.to} modifiers={['filter', 'price']} placeholder={`Any`}/>
        };

        return (
            <div className="range">
                { label ?
                 <div className="range__label">{label.text}</div>
                : null }

                <div className="range__field">
                    <div className="range__from">{from}</div>
                    <div className="range__between">to</div>
                    <div className="range__to">{to}</div>
                </div>
            </div>
        );
    }
}

export { Range };